<div *ngIf="isEnabled$ | async" @fadeOut class="banner">
  <div class="background" aria-hidden="true">
    <app-alert-banner-background-svg></app-alert-banner-background-svg>
    <app-alert-banner-background-svg></app-alert-banner-background-svg>
  </div>

  <opac-icon class="alert-icon" icon="alert"></opac-icon>

  <span ellipsis [lineClamp]="ellipsisLineClamp">{{ message }}</span>

  <opac-button class="close-button" (click)="closeBanner()" [ariaLabel]="'general.close' | translate" [opacTooltip]="'general.close' | translate">
    <opac-icon icon="close" slot="only-icon"></opac-icon>
  </opac-button>
</div>
